import React from 'react';
import { observer } from 'mobx-react';
import { ManagerEntity } from '@/shared/globalFunctions';

const ShowDevTextCheckbox = observer(() => {
  // Define state for the checkbox
  const isChecked = ManagerEntity._showDevInfo;

  // Handler for checkbox change
  const handleCheckboxChange = () => {
    ManagerEntity.showDevInfo = !ManagerEntity.showDevInfo;
  };

  return (
    <div>
      <label>
        <input
          type='checkbox'
          name='showDevSymbols'
          checked={isChecked}
          onChange={handleCheckboxChange}
        />
        Show Dev Text
      </label>
    </div>
  );
});

export default ShowDevTextCheckbox;